import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-fixed-asset-management',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterModule, FeatureHero, FeatureRow],
})
export class FixedAssets {
  whatIsParagraphs = [
    "Fixed asset management involves the systematic process of tracking, managing, and maintaining a company's physical assets. These assets include buildings, machinery, office equipment, and vehicles. That way, the value and lifespan of asset investments can be maximized.",
    "Effective fixed asset management ensures that all assets are accounted for and optimally utilized, reducing the risk of loss or theft while maintaining compliance. It also involves planning for asset replacements and upgrades, which can prevent unexpected downtime and enhance operational continuity."
  ];

  solutionParagraphs = [
    "Infraon's fixed asset management solution streamlines the tracking and management of physical assets. It provides real-time visibility into asset locations, conditions, and usage patterns to optimize asset utilization and maintenance schedules. Your users can monitor asset performance and make data-driven decisions.",
    "With Infraon's fixed asset management solution, it becomes easy to automate depreciation calculations and maintenance alerts. It supports detailed reporting and compliance, ensuring that all asset-related data is accurately documented and accessible.",
    "You can make informed decisions regarding asset acquisition, disposal, and overall financial planning."
  ];

  otherFeaturesItems = [
    'Customizable Reporting',
    'User and Role Management',
    'Audit Trails',
    'Mobile Accessibility'
  ];

  acquisitionParagraph = ["Identify and purchase your fixed assets without facing hassles as per business demands."];
  commissioningParagraph = ["Install and configure your fixed assets so that they are ready to be used."];
  utilizationParagraph = ["Start using your fixed assets while maximizing their performance."];
  maintenanceParagraph = ["Ensure preventive and corrective maintenance to keep your fixed assets in good shape always."];
  disposalParagraph = ["Sell or dispose of your fixed assets when they are no longer needed or cannot be used."];

  bestPracticesParagraph = ["Infraon's fixed asset management solution follows best practices that include:"];
  bestPracticesItems = [
    'Regular maintenance for prolonging the life of fixed assets and ensuring they operate efficiently',
    'Streamlined tracking and management processes for real-time visibility into fixed asset status',
    'Audits to confirm the existence and condition of fixed assets and address any discrepancies',
    'Proper classification and tagging of fixed assets by type, location, and usage',
    'Clear strategy for replacing assets to reduce clutter and free up resources'
  ];

  benefitsParagraph = ["Some of the benefits of Infraon's fixed asset management solution are:"];
  benefitsItems = [
    'Accurate inventory records for maintaining reliable stock levels while preventing overstocking or stock-outs',
    'Automated data capture for streamlining inventory management tasks',
    'No more asset misplacement with instant visibility into asset locations for employees to quickly locate items',
    'Maintenance schedule tracking for each asset, ensuring timely servicing and reducing the risk of downtime',
    'Prevention of theft and unauthorized movement of assets by providing clear records of asset locations and movement'
  ];

  constructor() {}

}